<template>
  <v-container fluid class="pa-0">
    <v-layout>
      <v-flex>
        <v-container>
          <v-layout row wrap v-if="from">
            <v-flex xs-12 sm-12 md-12 mb-5>
              <router-link class='ml-0 back-button' :to="from.fullPath" color="primary"><v-icon small color="primary">fa fa-arrow-left</v-icon> Return to Previous Page</router-link>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex v-if="profile || loading">
              <v-card class="user-profile" flat outlined tile>
                <div class="standard-fields-wrapper">
                  <v-avatar class="whit" size="100px" v-if="hasProfilePhoto">
                    <img :src="profilePhotoSrc" :key="profilePhotoSrc" v-if="hasProfilePhoto" style="border:1px solid #fff;" />
                    <span class="headline" style="font-size:40px !important;" v-else>{{profile.initials}}</span>
                  </v-avatar>
                  <div class="my-auto primary-fields-wrap" v-bind:class="{ hasPhoto: hasProfilePhoto }">
                    <h3 class="display-name">{{ displayName }}</h3>
                      <p class="profile-email" v-if="showEmail">{{ profile.email }}</p>
                    <div class="bio" v-if="profile.meta && profile.meta.bio">
                      {{ profile.meta.bio }}
                    </div>
                  </div>
                </div>

                <div class="" v-if="profile.meta && profile.meta.type">
                  <hr class="thick mt-2 mb-4" />
                  <default-fields v-if="profile.meta" :profile="profile.meta"></default-fields>
                  <hr class="thick mt-2 mb-4" />
                </div>
              </v-card>
              <div v-if="$auth.check('uber_admin') && extract('profile.id')">
                <amaze-user-groups :userId="this.$route.params.id"></amaze-user-groups>
              </div>
              <v-card-actions class='pl-0'>
                <v-btn v-if="isMe" color="primary" to='/profile/edit/' class='ml-0'>Edit</v-btn>
              </v-card-actions>
            </v-flex>
             <v-flex sm4 v-else>
               <h3>We were unable to locate this user.</h3>
             </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style lang="scss" scoped>
  @import "src/styles/variables.scss";
  .user-profile .standard-fields-wrapper {
    display: flex;
    align-items: center;

  }

  @media (max-width: 959px) {
    .primary-fields-wrap {
      padding-left: 20px;
    }
  }
</style>

<script>
import MemberService from "@/services/MemberService";
import DefaultFields from '@/components/Pages/Profile/View/Fields/Default';
import AmazeUserGroups from "@/components/Widgets/AmazeUserGroups";
import ExtractMixin from "@/mixins/extractMixin.js";

export default {
  components: [ AmazeUserGroups ],
  mixins: [ExtractMixin],
  data() {
    return {
      isMe: false,
      isUber: false,
      profile: null,
      displayName: null,
      flagRoleNames: null,
      hasProfilePhoto: false,
      from: null
    };
  },
  watch: {
    "$route.params.id": {
      handler: function(id) {
        // These steps were formerly in the created and beforeRouteEnter
        // properties of this component. Since we were running into
        // sporadic issues that appear to be timing sensitive race
        // conditions, I've moved this into a watch.
        const user = this.$auth.user();
        this.isThisUber(user.flags);
        const routeId = this.$route.params.id;
        if (routeId && typeof routeId !== 'undefined') {
          this.isThisMe(user, routeId);
          this.getProfile(routeId);
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    showEmail: function() {
      return this.isThisEdServices(this.profile);
    }
  },
  methods: {
    initializeProfile(id) {

    },
    setDisplayName(profile) {
      this.displayName = MemberService.getDisplayName(profile);
    },
    setFlagRoleNames(profile) {
      this.flagRoleNames = MemberService.getFriendlyFlagNames(profile);
    },
    setProfilePhoto(profile) {
      this.hasProfilePhoto = this.profile.profile_photo.hasOwnProperty("large");
      if (this.hasProfilePhoto) {
        this.profilePhotoSrc =
          this.profile.profile_photo.large + "?" + new Date().getTime();
      }
    },
    isThisMe(user, routeId) {
      this.isMe = !routeId || user["id"] === +routeId;
    },
    isThisUber(userFlags = []) {
      if (userFlags.length) {
        this.isUber = userFlags.find(flag => {
          return flag.id === 1;
        });
      }
    },
    isThisEdServices(profile) {
      if (profile.flags && profile.flags.length) {
        var edServices =
                profile.flags.find(flag => {
                  // TODO: Magic number, not good.
                  return flag.id === 6;
                });

        return edServices;
      }

      return false;
    },
    getProfile(id) {
      this.$store.commit("loading", { loading: true });
      return MemberService.getProfile(id).then(
        response => {
          this.profile = response;
          this.setDisplayName(this.profile);
          this.setFlagRoleNames(this.profile);
          this.setProfilePhoto(this.profile);
          this.$store.commit("loading", { loading: false });
        },
        response => {
          console.error("[error] getProfile");
          this.$store.commit("loading", { loading: false });
        }
      );
    }
  },
  created() {
    // TODO: This may no longer be needed.
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // If user id is empty (i.e. url is /profile), then load current user.
      // This presumes that /profile requires authentication to access, which
      // is always true as of 2022-06-20.
      const routeId = to.params.id;
      if (routeId && typeof routeId !== 'undefined') {
        // Do nothing. We're good here.
      } else {
        const user = vm.$auth.user();
        next("/profile/" + user.id);
      }
    });
  }
};
</script>
